module.exports = __webpack_public_path__ + "img/redwulf-40A.9780b922.png";